const ro = {
    'Source name': 'Denumire sursă',
    'Client sources': 'Surse client',
    'Client sources administration': 'Administrare surse client',
    'Add client source': 'Adaugă sursă client',
    'Edit client source': 'Editează sursă client',
    Source: 'Sursă',
    'This client source has been successfully deleted!': 'Această sursă de client a fost ștearsă cu succes!',
    'This client source has been updated successfully!': 'Această sursă de client a fost actualizată cu succes!',
    'Client source was successfully added!': 'Sursa de client a fost adăugată cu succes!',
    'Are you sure you want to delete this client source?': 'Sigur doriți să ștergeți această sursă de client?',
    'Something went wrong! This client resource could not be deleted!':
        'Ceva n-a mers bine! Această sursă de client nu a putut fi ștearsă!',
    'There is already a client source with this name!': 'Există deja o sursă de client cu acest nume!',
    'The client source is mandatory!': 'Sursa este obligatorie!',
};

export default { ro };
